import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { DownloadService } from '../../modules/shared/services/download.service';
import { DocumentLinkComponent } from './document-link.component';

@NgModule({
    imports: [ DocumentLinkComponent ],
    providers: [ DownloadService ]
})
export class DocumentLinkModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(DocumentLinkComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-document-link', el);
    }
}
